module.exports = __webpack_public_path__ + "img/panda.fd362c8b.svg";